import 'bootstrap/js/dist/tooltip';
import $ from 'jquery';

$(() => $('.discount-pill').tooltip());
